import { Step } from "@app/core/on-boarding/domain/model/step";
import { Observable } from "rxjs";

export abstract class StepRepo {
  abstract getSteps(): Observable<Step[]>;
}
